<template>
  <div class="box">
    <div class="box_header">
      <div class="box_header_title">
        <img src="@/assets/images/bigData/box_header_icon.png" alt="" />
        <slot name="title">{{ title }}</slot>
        <slot name="title_right"></slot>
      </div>
    </div>
    <div :class="showBg ? 'box_content_bg' : ''" class="box_content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
      require: true,
    },
    showBg: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 16px;
  &_header {
    display: flex;
    min-height: 43px;
    align-items: center;
    background: url("~@/assets/images/bigData/bg2.png") no-repeat;
    background-size: 100% 100%;
    &_title {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 1.05vw;
      // font-size: 20px;
      color: #02f4f5;
      text-align: left;
      font-style: normal;
      text-transform: none;
      width: 100%;
      display: flex;
      align-items: center;
      > img {
        width: 18px;
        height: 18px;
        margin: 10px;
        margin-right: 15px;
      }
    }
    padding-right: 21px;
    margin-bottom: 6px;
  }
  &_content {
    padding: 0.4vw;
    padding-bottom: 0;
    padding-top: 1vh;
    flex: 1;
    width: 100%;
    height: auto;
    display: flex;
    // min-height: 250px;
    background-size: 100% 100%;
    overflow: hidden;
    &_bg {
      background: url("~@/assets/images/bigData/box_bg.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}
::v-deep .ant-select-selection {
  background-color: #01297d;
  color: #fff;
  border-color: #2669e6;
}
::v-deep .ant-select-dropdown {
  background-color: #01297d;
  color: #fff;
}
::v-deep .ant-select-arrow {
  background-color: #01297d;
  color: #fff;
}
::v-deep .ant-radio-button-wrapper {
  color: #999;
  background-color: #0d308d;
  border-color: #ffffff00;
  border-radius: 0;
}
</style>
<style lang="scss">
.customClass {
  background: #01297d;
  .ant-select-dropdown-menu-item {
    background-color: #01297d;
    color: #fff;
    &:not(:last-child) {
      border-bottom: 1px solid #999;
    }
    &:hover:not(.ant-select-dropdown-menu-item-disabled) {
      background-color: #0f5bff;
    }
  }
}
</style>